import { useQuery } from '@tanstack/react-query';
import { useUniversalNavContext } from './useUniversalNavContext';

type AccountRestrictedResponse = {
  status: 'success';
  approval_required: boolean;
};

export const useQueryAccountRestriction = (currentAccountId?: number) => {
  const { apiHostname } = useUniversalNavContext();

  const result = useQuery<AccountRestrictedResponse>({
    queryKey: ['accountRestriction', currentAccountId] as const,
    queryFn: async () => {
      if (!currentAccountId) {
        return undefined;
      }
      const url = new URL(
        `/api/checkpoint/v1/account-restrictions/`,
        apiHostname || window.location.origin
      );

      const response = await fetch(url.toString(), {
        credentials:
          process.env.NODE_ENV !== 'test' ? 'include' : 'same-origin',
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const json = await response.json();

      return json;
    },
    staleTime: 1000 * 10,
    enabled: !!currentAccountId,
  });

  return {
    ...result,
    isLoading: result.isInitialLoading,
  };
};
